module.exports = __webpack_public_path__ + "img/咒骂.b382537d.gif";